import script from "./CustomCursor.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCursor.vue?vue&type=script&setup=true&lang=js"

import "./CustomCursor.vue?vue&type=style&index=0&id=3c9604a5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9604a5"]])

export default __exports__